import React, { useEffect } from 'react'
import {
  FormControl,
  FormHelperText,
  FilledInput,
  OutlinedInput,
  InputLabel,
  Input,
  Select,
} from '@material-ui/core'
import { withFormsy } from 'formsy-react'
import _ from '@lodash'
import * as R from 'ramda'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  selectMenu: {
    '& .MuiListItem-root': {
      padding: '0 !important',
    },
  },
}))

function LightSelector(props) {
  const importedProps = _.pick(props, [
    'autoWidth',
    'children',
    'classes',
    'displayEmpty',
    'input',
    'inputProps',
    'MenuProps',
    'multiple',
    'native',
    'onChange',
    'onClose',
    'onOpen',
    'open',
    'renderValue',
    'SelectDisplayProps',
    'inputRef',
    'value',
    'variant',
  ])
  const classes = useStyles()
  const FormControlProps = R.prop('FormControlProps')(props)

  // An error message is returned only if the component is invalid
  const errorMessage = props.errorMessage
  const value = props.value

  function input() {
    switch (importedProps.variant) {
      case 'outlined':
        return (
          <OutlinedInput
            labelWidth={R.pathOr(0, ['label', 'length'], props) * 8}
            id={props.name}
          />
        )
      case 'filled':
        return <FilledInput id={props.name} />
      default:
        return <Input id={props.name} />
    }
  }

  function changeValue(event) {
    const oldValue = props.value
    if (!R.equals(oldValue, event.target.value)) {
      props.setValue(event.target.value)
    }
    if (props.onChange) props.onChange(event)
  }

  useEffect(() => {
    if (props.name === 'voucher' && !props.isEditMode && props.voucherCreated) {
      props.setValue(props.voucher)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.voucher])

  const shouldShowErrorMsg = Boolean(errorMessage) && !props.isPristine

  return (
    <FormControl
      error={shouldShowErrorMsg}
      className={props.className}
      variant={importedProps.variant}
      required={props.required}
      {...FormControlProps}
      disabled={props.disabled}
    >
      {props.label && (
        <InputLabel htmlFor={props.name}>{props.label}</InputLabel>
      )}
      <Select
        {...importedProps}
        className={classes.selectMenu}
        value={value}
        onChange={changeValue}
        input={input()}
      />
      {shouldShowErrorMsg && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  )
}

export default React.memo(withFormsy(LightSelector))
